import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-evo-segment-selection-button',
  templateUrl: './evo-segment-selection-button.component.html',
  styleUrls: ['./evo-segment-selection-button.component.css']
})
export class EvoSegmentSelectionButtonComponent implements OnInit {

  /**
   * The current value of the selection string which
   * decided whether the button is in selected state
   * or not.
   */
  @Input() selectionValue: string;
  @Input() selectionKey: string;

  @Input() imgURL: string;
  @Input() selectionImgURL: string;

  @Input() text: string;

  @Output() click = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  isSelected(): boolean {

    if (this.selectionValue && this.selectionKey &&
      this.selectionValue === this.selectionKey) {
      return true;
    }

    return false;

  }

  imgSrc(): string {

    if (this.isSelected()) {
      return this.selectionImgURL;
    }

    return this.imgURL;

  }

  clickHandler() {
    if (this.click) {
      this.click.next();
    }
  }

}
